export class CreateWorkflowRequest {
  Name: string = '';
  Description: string = '';

  constructor(values: Partial<CreateWorkflowRequest> = {}) {
    Object.assign(this, values);
  }
}
